// extracted by mini-css-extract-plugin
export default {"LinkIcon":"_LinkIcon--eDfKR"};